import { render, staticRenderFns } from "./PzTitleBanner.vue?vue&type=template&id=71414674"
import script from "./PzTitleBanner.vue?vue&type=script&lang=js"
export * from "./PzTitleBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71414674')) {
      api.createRecord('71414674', component.options)
    } else {
      api.reload('71414674', component.options)
    }
    module.hot.accept("./PzTitleBanner.vue?vue&type=template&id=71414674", function () {
      api.rerender('71414674', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/commons/titles/PzTitleBanner.vue"
export default component.exports